module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-container"
  }, [_c('q-slider', {
    staticClass: "picker-question",
    attrs: {
      "dots": ""
    },
    on: {
      "slide": _vm.slide
    }
  }, [_c('SchoolLevelSlide', {
    on: {
      "next": _vm.next
    },
    slot: "slide"
  }), _vm._v(" "), _c('PostalCodeSlide', {
    on: {
      "done": _vm.done,
      "back": _vm.back,
      "next": _vm.next
    },
    slot: "slide"
  }), _vm._v(" "), _c('CcaSlide', {
    on: {
      "done": _vm.done,
      "back": _vm.back,
      "next": _vm.next
    },
    slot: "slide"
  }), _vm._v(" "), _c('OthersSlide', {
    on: {
      "done": _vm.done,
      "back": _vm.back,
      "next": _vm.next
    },
    slot: "slide"
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30664c16", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30664c16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionView/index.vue
// module id = 846
// module chunks = 0